import LicenseEdit from './LicenseEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { Button, Space, Tooltip } from 'antd';
import { columnsheadId } from '../../universal/columnshead';
import LicenseExtend from './LicenseExtend';
import { useEffect, useRef, useState } from 'react';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

//组件 License 
const License = (props: any) => {
    const apiId = 'license';
    const ref = useRef<any>(undefined);
    const [modalLicenseExtend, setModalLicenseExtend] = useState(false);
    const [licenseInfo, setLicenseInfo] = useState<any>();
    const [licenseTypeData, setLicenseTypeData] = useState<any>();
    const [licenseGroupData, setLicenseGroupData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>()
    const [fetchData, setFetchData] = useState<any>();
    const [defaultService, setDefaultService] = useState<string>('');

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService
            setDefaultService(urlService);
            setFetchData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'licenseType',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { licenseType } = res.data;
                    setLicenseTypeData([{ id: 'ALLITEM', name: '所有' }, ...licenseType]);
                }
            })
        fetchApi.GET(urlService, {
            query: {
                apiId: 'licenseGroup',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setLicenseGroupData([{ id: 'ALLITEM', licenseGroupName: '所有' }, ...res.data]);
            }
        })
    }, []);

    /** 打开extend */
    const openExtend = (record: any) => {
        setLicenseInfo({
            id: record.id,
            licenseName: record.licenseName
        })
        setModalLicenseExtend(true);
    };

    //子组件回调函数，关闭modal
    const onCloseModalExtend = (state: boolean) => {
        setModalLicenseExtend(false)
    };

    /**
     * 表头内容
     */
    const columnsHead = [
        {
            title: '权限',
            dataIndex: 'licenseName',
            sorter: true,
        },
        {
            title: '类型',
            dataIndex: 'licenseType',
            render: (val: any) => {
                let name = '';
                if (val) {
                    for (let i = 0; i < val.length; i++) {
                        const element = val[i];
                        if (name !== '') { name += ','; }
                        name += element?.name;
                    }
                }
                return name;
            }
        },
        {
            title: '权限组',
            dataIndex: 'licenseGroup',
            sorter: true,
            render: (val: any) => (val?.licenseGroupName)
        },
        {
            title: '页面路径',
            dataIndex: 'pageUrl',
            render: (val: any, record: any) => <Tooltip placement="topLeft" title={val}>{
                val ? (val.length >= 20 ? '......' + val.substring(0, 20) : val) : ''
            }</Tooltip>,
        },
        {
            title: '排序',
            dataIndex: 'sort',
            sorter: true,
        },
        {
            title: '扩展',
            dataIndex: 'apiExtend',
            render: (val: any, record: any) =>
                <Space size="small">
                    <Button size={"small"} onClick={() => openExtend(record)}>扩展</Button>
                </Space>
        },
    ];
    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);
    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '权限',
        apiId,
        columns,
        expandableOptions: {
            isTree: true,
            subColumns: columns,
            subDataName: 'children',
            isSameMainDisplayOptions: true,
        },
        editOptions: {
            Editor: LicenseEdit
        }
    };

    return (
        <> <Space>
            <CustomSelect
                apiId={apiId}
                sendKeyId='licenseTypeId'
                getListData={licenseTypeData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
            />
            <CustomSelect
                apiId={apiId}
                sendKeyId='licenseGroupId'
                getListData={licenseGroupData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="licenseGroupName"
            />
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalLicenseExtend ? (<LicenseExtend
                closeModal={onCloseModalExtend}
                info={licenseInfo}
                useType={'roleLicense'} />)
                : null}
        </>
    )
}

export default License;